/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "BandRouteMapService";
const log: any = LoggerModule.getInstance();

export class BandRouteMapService {
  private static instance: BandRouteMapService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): BandRouteMapService {
    if (!BandRouteMapService.instance) {
      BandRouteMapService.instance = new BandRouteMapService(props);
    }
    return BandRouteMapService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentations() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getPresentationsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getBandRoute(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getBandRouteProps(args);
  }
}
